import type { AutocompleteBody, AutocompleteParams } from "@apptus/esales-api";
import elevateClient from "@server/elevate";

import { marketCode } from "@features/market/config/market-config";
import type { ElevateMarket } from "./utils";

import mapCustomAttributes from "./mapCustomAttributes";

export default async function getAutocomplete(
  market: ElevateMarket,
  input: AutocompleteParams,
  config?: AutocompleteBody,
) {
  const code = marketCode(market).toLowerCase();
  return elevateClient(market).query.autocomplete(
    {
      ...input,
      notify: process.env.NEXT_PUBLIC_ENVIRONMENT === "prod",
      presentCustom: mapCustomAttributes([], market),
      presentPrices: [
        `NG_${code}_best`,
        `NG_${code}_RRP`,
        `NG_${code}_pricematch`,
        `NG_${code}_campaign`,
      ],
      priceId: `NG_${code}_best`,
    },
    {
      contentLists: [
        {
          id: "designers",
          limit: 3,
          contentFilter: {
            type: ["designer"],
          },
        },
        {
          id: "brands",
          limit: 3,
          contentFilter: {
            type: ["brand"],
          },
        },
        {
          id: "categories",
          limit: 3,
          contentFilter: {
            type: ["category"],
          },
        },
      ],
      ...config,
    },
  );
}
